<script>
  import Spinner from './Spinner.svelte';
  import Table from './Table.svelte';

  const pat =
    'patSuxEKMLyRVU7RQ.4f2c5d5b19cab064954a688ce8f1f3a232b3092e5143b6456105143ee64bc4a0';
  let airtable_read_endpoint =
    'https://api.airtable.com/v0/appWi2NKdxWtPIdlx/Thes?maxRecords=100&view=api';
  let data = {};

  function sortByName(a, b) {
    if (a && a.fields && a.fields.name && b && b.fields && b.fields.name) {
      return (
        (a.fields.name[0] > b.fields.name[0]) -
        (a.fields.name[0] < b.fields.name[0])
      );
    }
    return 0;
  }

  function sortByBrand(a, b) {
    if (a && a.fields && a.fields.brand && b && b.fields && b.fields.brand) {
      return (
        (a.fields.brand[0] > b.fields.brand[0]) -
        (a.fields.brand[0] < b.fields.brand[0])
      );
    }
    return 0;
  }

  $: sortedVrac = data?.records
    ?.filter((rec) => rec.fields.type[0] == 'vrac')
    .sort(sortByName)
    .sort(sortByBrand);

  $: sortedSachets = data?.records
    ?.filter((rec) => rec.fields.type[0] == 'sachet')
    .sort(sortByName)
    .sort(sortByBrand);

  async function fetchData() {
    const res = await fetch(airtable_read_endpoint, {
      headers: { Authorization: `Bearer ${pat}` },
    });
    data = await res.json();

    if (res.ok) {
      return data;
    } else {
      throw new Error(data);
    }
  }
</script>

<main
  class="w-92 md:w-240 shadow-2xl mx-auto my-1 md:my-5 pt-2 md:pt-4 pb-6 px-4 md:px-10 text-gray-900 font-sans-serif flex flex-col bg-white"
>
  <div class="">
    <h1 class="text-5xl text-center mt-6 md:mt-10 font-cursive">Tea Menu</h1>

    {#await fetchData()}
      <Spinner></Spinner>
    {:then fetchedData}
      <h2 class="text-xl mt-6 md:mt-10 mb-4">En vrac</h2>
      <Table rows={sortedVrac}></Table>

      <hr class="mt-6" />

      <h2 class="text-xl mt-6 md:mt-10 mb-4">En sachets</h2>
      <Table rows={sortedSachets}></Table>
    {:catch error}
      <p class="text-red-500">{error.message}</p>
    {/await}
  </div>
</main>
